(function(){
  'use strict';

  var DEBUG = Boolean(window.__LAZY_GALLERY_DEBUG);
  var userInteracted = false; // prevent auto-loading non-hero until user interacts
  var preloadedUrls = new Set();
  var inFlightPreloads = new Set();

  // helper: build url with width param
  function buildUrlForWidth(url, w){
    try{
      if(/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
      if(url.indexOf('?') !== -1) return url + '&width=' + w;
      return url + '?width=' + w;
    }catch(e){ return url; }
  }

  var candidateWidths = [200, 480, 980, 1946];

  function pickPreferred(url, img){
    var dpr = window.devicePixelRatio || 1;
    var rendered = (img && (img.clientWidth || img.width)) || Math.round((window.innerWidth || 1024) * 0.5);
    var preferred = candidateWidths.filter(function(w){ return w >= Math.round(rendered * dpr); })[0] || candidateWidths[candidateWidths.length-1];
    return buildUrlForWidth(url, preferred);
  }

  

  function loadLargeForSlide(slide){
    if(!slide || slide.dataset.loadedLarge === 'true') return;
    var img = slide.querySelector('img');
    if(!img) return;
    var large = slide.dataset.pswpSrc || slide.dataset.src || img.dataset.large || img.dataset.src || img.getAttribute('data-large');
    if(!large){ return; }
    

    // If image is inside a <picture>, remove <source> tags so browser won't pick smaller srcset
    try{
      var picture = img.closest('picture');
      if(picture){
        var sources = picture.querySelectorAll('source');
        sources.forEach(function(s){ s.remove(); });
      }
    }catch(e){ /* ignore */ }

    // Apply responsive sizing if available
    var sizes = slide.dataset.sizes || img.getAttribute('sizes') || '100vw';
    try{ img.sizes = sizes; }catch(e){}

    // Build multiple srcset candidates so browser can pick appropriate size
    var srcsetEntries = candidateWidths.map(function(w){ return buildUrlForWidth(large, w) + ' ' + w + 'w'; }).join(', ');

    try{ img.sizes = sizes; }catch(e){}
    try{ img.srcset = srcsetEntries; }catch(e){}

    // Pick preferred candidate using shared logic
    var chosen = pickPreferred(large, img);

    // If already preloaded, swap immediately
    if(preloadedUrls.has(chosen) || img.src === chosen){
      try{
        img.srcset = srcsetEntries;
        img.sizes = sizes;
        img.src = chosen;
        slide.dataset.loadedLarge = 'true';
        slide.dataset.loadedLargeUrl = chosen;
        img.classList && img.classList.add('lazy-loaded');
        img.classList && img.classList.remove('image-lazy');
      }catch(e){}
      return;
    }

    // Preload chosen image and swap only after load to avoid showing blurred preview
    var pre = new Image(); pre.decoding = 'async';
    pre.onload = function(){
      try{
        img.srcset = srcsetEntries;
        img.sizes = sizes;
        img.src = pre.src;
        slide.dataset.loadedLarge = 'true';
        slide.dataset.loadedLargeUrl = pre.src;
        preloadedUrls.add(pre.src);
        img.classList && img.classList.add('lazy-loaded');
        img.classList && img.classList.remove('image-lazy');
      }catch(e){}
    };
    pre.onerror = function(){
      // Fallback: directly set src
      try{ img.src = chosen; slide.dataset.loadedLarge = 'true'; slide.dataset.loadedLargeUrl = chosen; img.classList && img.classList.add('lazy-loaded'); img.classList && img.classList.remove('image-lazy'); }catch(e){}
    };
    // mark in-flight for chosen
    inFlightPreloads.add(chosen);
    pre.onload && pre.onload.bind(pre);
    pre.src = chosen;
    // once src set, ensure inFlight tracking cleaned
    pre.addEventListener('load', function(){ inFlightPreloads.delete(chosen); });
    pre.addEventListener('error', function(){ inFlightPreloads.delete(chosen); });
  }

  function preload(url){ if(!url) return; var i=new Image(); i.src=url; }

  // improved preload: de-duplicate and pick preferred candidate based on image size
  function preloadPreferred(baseUrl, img){
    if(!baseUrl) return;
    var chosen = pickPreferred(baseUrl, img);
    if(preloadedUrls.has(chosen)) { return; }
    if(inFlightPreloads.has(chosen)) { return; }
    inFlightPreloads.add(chosen);
    var p = new Image(); p.decoding = 'async';
    p.onload = function(){ preloadedUrls.add(chosen); inFlightPreloads.delete(chosen); };
    p.onerror = function(){ inFlightPreloads.delete(chosen); };
    p.src = chosen;
  }

  function onInteraction(e){
    // mark that user has interacted — allow non-hero loads from now on
    userInteracted = true;
    var target = e.target;
    var thumbsItem = target.closest('.product__thumbs-item');
    if(thumbsItem){
      var targetMediaId = thumbsItem.getAttribute('data-target');
    
      if(targetMediaId){
        var slide = document.querySelector(`.product__media-item[data-media-id="${targetMediaId}"]`);
        loadLargeForSlide(slide);
        // preload neighbors
        if(slide && slide.parentElement){
          var children = Array.from(slide.parentElement.children);
          var idx = children.indexOf(slide);
          [idx-1, idx+1].forEach(function(i){ if(i>=0 && children[i]) preloadPreferred(children[i].dataset.pswpSrc || children[i].dataset.src, children[i].querySelector('img')); });
        }
      }
    }
  }

  function observeActiveSlides(root){
    var list = root.querySelector('.product__media-list');
    if(!list) return;
    var observer = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        if(m.type === 'attributes' && m.attributeName === 'class'){
          var target = m.target;
          if(target.classList && target.classList.contains('swiper-slide-active')){
            
            // Only auto-load when user has interacted, unless this is the hero (index 0)
            var idx = target.dataset.mediaIndex || target.getAttribute('data-media-index');
            if(String(idx) === '0' || userInteracted){
              loadLargeForSlide(target);
            } else {
              
            }
            // preload neighbors (use preferred candidate and de-duplicate)
            var siblings = Array.from(target.parentElement.children);
            var idx = siblings.indexOf(target);
            [idx-1, idx+1].forEach(function(i){ if(i>=0 && siblings[i]) preloadPreferred(siblings[i].dataset.pswpSrc || siblings[i].dataset.src, siblings[i].querySelector('img')); });
          }
        }
      });
    });

    // observe class changes on slides
    var slides = list.children;
    Array.prototype.forEach.call(slides, function(s){ observer.observe(s, { attributes: true, attributeFilter: ['class'] }); });

    // load initial active slide (if any) — only load if it's the hero (index 0)
    var active = list.querySelector('.swiper-slide-active');
    if(active){
      var idx = active.dataset.mediaIndex || active.getAttribute('data-media-index');
      if(String(idx) === '0'){
        loadLargeForSlide(active);
      }
    }
  }

  function init(){
    var roots = document.querySelectorAll('media-gallery, [id^="MediaGallery-"]');
    if(!roots.length) roots = [document];
    roots.forEach(function(root){
      if(root && root.dataset && root.dataset.lazyGalleryDebug === 'true') DEBUG = true;
      // bind interaction on thumbnails
      root.addEventListener('pointerdown', onInteraction, {passive:true});
      root.addEventListener('touchstart', onInteraction, {passive:true});
      observeActiveSlides(root);

      // also attach click handler for next/prev buttons to load upcoming
      var next = root.querySelector('.swiper-button-next');
      var prev = root.querySelector('.swiper-button-prev');
      if(next){ next.addEventListener('click', function(){
        var list = root.querySelector('.product__media-list');
        var active = list && list.querySelector('.swiper-slide-active');
        if(active && active.nextElementSibling) loadLargeForSlide(active.nextElementSibling);
      }); }
      if(prev){ prev.addEventListener('click', function(){
        var list = root.querySelector('.product__media-list');
        var active = list && list.querySelector('.swiper-slide-active');
        if(active && active.previousElementSibling) loadLargeForSlide(active.previousElementSibling);
      }); }
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
